<template>
    <section class="hero section center-content" :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container-sm">
            <div class="hero-inner section-inner" :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div class="hero-content">
                    <figure>
                        <c-image class="image-larger"
                            :src="require('@/assets/images/struvital-images/StruVital_LOGO_transparent_cropped.png')"
                            alt="Image placeholder" :width="712" :height="400" />
                    </figure>
                    <h1 class="mt-0 mb-16 reveal-from-top">
                        {{ $t('welcome-to-struvital') }}
                    </h1>
                    <div class="container-xs">
                        <p class="m-0 mb-32 reveal-from-top" data-reveal-delay="150">
                            {{ $t('we-are-developing') }}
                        </p>
                        <vimeo-player ref="player" :video-id="videoID1" :options="video1Options" :player-height="height"
                            @ready="onReady"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CImage from '@/components/elements/Image.vue'

export default {
    name: 'CHeroFull',
    mixins: [SectionProps],
    components: {
        CImage,
    },
    data() {
        return {
            videoID1: '871767170',
            height: 600,
            video1Options: {
                title: false,
                autopause: true,
                portrait: true,
                byline: true,
                responsive: true,
                muted: false,
                loop: true,
                background: true
            },
            playerReady: false,
        }
    },
    methods: {
        onReady() {
            this.playerReady = true
        },
        play() {
            this.$refs.player.play()
        },
        stop() {
            this.$refs.player.stop()
        },
    },
}
</script>

<style scoped>
@media (min-width: 641px) {
  .hero-content {
    margin-bottom: 40px;
  }
}

.container-xs >>> iframe {
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}
</style>	